import React from 'react'
import {Navbar, Container, Nav} from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import useAuth from '../../context/auth/useAuth'


export default function MenuAdministrative({background='transparent',fixed=''}) {
	const { t } = useTranslation()
	const {logout} = useAuth()
  	return (
		<Navbar expand="xs" fixed="top" id="menu-admin" className={`mb-5 `+ fixed}>
			<Container fluid className="justify-content-between">
				<span className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#basic-navbar-nav" aria-controls="basic-navbar-nav" aria-expanded="false" aria-label="Toggle navigation">
					<i className="fas fa-bars"></i>
				</span>
				<div className="navbar-brand">
					<img
						src="/images/logotipo.png"
						className="d-inline-block align-top justify-center"
						alt="Logotipo SD Agro"
						id="logo-menu"
					/>
				</div>
				<div className="navbar-start"></div>
				<Navbar.Collapse id="basic-navbar-nav">
					<Nav className="text-start">	
						<Nav.Link href="/administrative/dashboard">{t('menu.dashboard')}</Nav.Link>
					</Nav>
				</Navbar.Collapse>
				<Navbar.Collapse id="basic-navbar-nav">
					<Nav className="text-start">	
						<Nav.Link href="/administrative/cards">{t('menu.confirmcards')}</Nav.Link>
					</Nav>
				</Navbar.Collapse>
				<Navbar.Collapse id="basic-navbar-nav">
					<Nav className="text-start">	
						<Nav.Link href="/administrative/cardschange">{t('menu.changecards')}</Nav.Link>
					</Nav>
				</Navbar.Collapse>
				<Navbar.Collapse id="basic-navbar-nav">
					<Nav className="text-start">	
						<Nav.Link href="/administrative/reports">{t('menu.reports')}</Nav.Link>
					</Nav>
				</Navbar.Collapse>
				<Navbar.Collapse id="basic-navbar-nav">
					<Nav className="text-start">	
						<Nav.Link href="#" onClick={logout}>{t('menu.logout')}</Nav.Link>
					</Nav>
				</Navbar.Collapse>
			</Container>
		</Navbar>
	)
}
